import env from '../../utils/env';
import request from './request';

export const uploadImageToCdn = (formData) => {
  const endpoint = `${env.aceApi}api/1/admin/products/image`;
  return request(endpoint, 'POST', {}, formData);
};

export const deleteImagesFromCdn = (fileUrls) => {
  const endpoint = `${env.aceApi}api/1/admin/products/images`;
  const data = JSON.stringify(fileUrls);
  return request(
    endpoint,
    'DELETE',
    { 'Content-Type': 'application/json' },
    data
  );
};
